import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.DealerClaimType.Delete.IRequest;
type Response = Api.Core.DealerClaimType.Delete.IResponse;
type Headers = Api.Core.DealerClaimType.Delete.IHeaders;
const saveApiDealerClaimTypePath = '/api/DealerManagement/DealerClaimType/:id';
export default async function dealerClaimTypeDeleteApi(params: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    url: createPathFromRoute(saveApiDealerClaimTypePath, params, null),
    method: HttpMethod.delete,
    headers: getDefaultHeaders(),
  });
}
